module.exports = __webpack_public_path__ + "static/img/Water.b71209e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/elements/Water.svg
// module id = 1423
// module chunks = 0